"use strict";
// tslint:disable
/**
 * Notifications service API
 * Topic based notification system.  This service's responsibility is to distribute notifications over various channels to subscribers.  Subscribers subscribe to a topic by device and can add subject filtering in the subscription.  A topic will typically be a service name like `platform-api-conversations`.  A topic can be thought of as a broad base of related events.  A subscription is for an endpoint and will generally be targeted to specific interests of an application.  For example, a chat application would be interested in the `platform-api-conversations` topic.  It could add and remove subscriptions based on the context of what a user is currently seeing.  If a user was viewing a conversation, they could have a subject filter like `/conversations/{conversationId}/messages`.  Subject filters are limited regular expressions thus without special regex constructs semantically equate to 'contains'.  Most regex patterns are not supported and many are forbidden.  The following regex constructs are not supported and will be forbidden at a later date:  backrefences, groups, captures, and `.*` matches.  Any patterns supplied outside of the the supported set could cease to function without warning.  Supported subject filter examples are as follows: * publications for a resource and its subresources: `/conversations/{conversationId}` * publications for a base resource: `/users/{userId}$` * publications for a filtered subresources: `/cti/endpoints/\\d\\d\\d#/calls`.  Subscriptions have a transport which is a channel over which the publication will be delivered.  Each transport has unique characteristics and requirements.  The deviceId field has different meanings and restrictions depending on the transport: * websocket:  unique identifier for the client socket which cannot contain the characters `#`, `$`, `+` and must be shorter than 128 bytes * mobile:  device token provided by native push system * aws-lambda:  arn of the lambda to invoke * webhook:  target POST URL Likewise the applicationId field has transport specific meanings: * mobile:  platform registered applicationId * webhook:  publication secret for caller verification * others: not used  Publishers have the option to supply a subscription filter to restrict distribution of the publication.  Subscription filters are jsonpath expressions given a data structure of `{ subscriptions: [subscription1, subscription2, etc] }`.  Examples of subscription filters: * single user:  `$.subscriptions[?(@.userId == 'user1@mitel.com')]` * multiuser:  `$.subscriptions[?(@.userId == 'user1@mitel.com' || ?(@.userId == 'user2@mitel.com')]`
 *
 * OpenAPI spec version: 2017-09-01
 * Contact: cloudlink.support@mitel.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually. Blah blah blah
 */
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const URLSearchParams = require('url-search-params');
const utils_1 = require("../utils");
const service_requester_1 = require("../service-requester");
// @ts-ignore
const separators = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 * NotificationsService
 * @class
 */
class NotificationsService {
    /**
     * @constructor
     */
    constructor(params = {}) {
        this.serviceRequester = params.serviceRequester || new service_requester_1.ServiceRequester(Object.assign({ service: 'Notifications' }, params));
    }
    /**
    * Gets the history of notifications (either delivered, failed to deliver, or timed out) as a result of publications that match your subscriptions. Notifications are only recorded if the `recordNotifications` flag is true on the subscription. Only one of $skip and $skipToken may be defined in a query. *Available Filter Operations*: [lt, gt, and, eq, ne]. [eq, ne] not supported on `createdOn`.
    * @summary Get the history of notifications based on your subscriptions
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [$Orderby] Determines the order in which items are returned based on a provided property and sort order (&#39;desc&#39; for descending or &#39;asc&#39; for ascending). Currently only supports sorting on the &#39;createdOn&#39; property.  Example: ?$orderby&#x3D;createdOn desc
    * @throws {RequiredError}
    */
    getNotifications(params) {
        const path = `/notifications`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create new publication connections such as websocket URLs.
    * @summary Create new connections for publications
    * @param {ConnectionPostRequest} body Subscription POST request object
    * @throws {RequiredError}
    */
    createConnection(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createConnection.');
        }
        const path = `/connections`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Sends multiple publications by accepting a batch of operations in an array. Each operation consists of the action to take (only 'add' supported at this time), path (only '/publications' supported at this time), and value which consists of the normal content of a publication POST.
    * @summary Sends multiple publications
    * @param {PublicationPatchRequest} body Publication PATCH request object
    * @throws {RequiredError}
    */
    patchPublications(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling patchPublications.');
        }
        const path = `/publications`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PATCH', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Sends a publication to subscribers.
    * @summary Send a publication
    * @param {PublicationPostRequest} body Publication POST request object
    * @throws {RequiredError}
    */
    publish(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling publish.');
        }
        const path = `/publications`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides this specification defining the resources of the microservice API
    * @summary Get API spec
    * @throws {RequiredError}
    */
    getSpec(params) {
        const path = `/_spec`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides the status of the microservice
    * @summary Get microservice status
    * @throws {RequiredError}
    */
    getStatus(params) {
        const path = `/_status`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a subscription.
    * @summary Create a subscription
    * @param {SubscriptionPostRequest} body Subscription POST request object
    * @throws {RequiredError}
    */
    createSubscription(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createSubscription.');
        }
        const path = `/subscriptions`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the subscription for the provided ID.
    * @summary Delete a subscription
    * @param {string} subscriptionId SubscriptionId
    * @throws {RequiredError}
    */
    deleteSubscription(params) {
        // verify required parameter 'subscriptionId' is not null or undefined
        if (params.subscriptionId === null || params.subscriptionId === undefined) {
            throw new utils_1.RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling deleteSubscription.');
        }
        const path = `/subscriptions/{subscriptionId}`
            .replace(`{${'subscriptionId'}}`, String(params.subscriptionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the subscription for the provided ID.
    * @summary Get a subscription
    * @param {string} subscriptionId SubscriptionId
    * @throws {RequiredError}
    */
    getSubscription(params) {
        // verify required parameter 'subscriptionId' is not null or undefined
        if (params.subscriptionId === null || params.subscriptionId === undefined) {
            throw new utils_1.RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling getSubscription.');
        }
        const path = `/subscriptions/{subscriptionId}`
            .replace(`{${'subscriptionId'}}`, String(params.subscriptionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the user's subscriptions. Only one of $skip and $skipToken may be defined in a query. *Available Filter Operations*: [eq, ne, lt, le, gt, ge, and, or, substringof('fullString', 'substring')]
    * @summary Get subscriptions
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @throws {RequiredError}
    */
    getSubscriptions(params) {
        const path = `/subscriptions`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the subscription for the provided ID.
    * @summary Update a subscription
    * @param {string} subscriptionId SubscriptionId
    * @param {SubscriptionPutRequest} body Subscription PUT request
    * @throws {RequiredError}
    */
    updateSubscription(params) {
        // verify required parameter 'subscriptionId' is not null or undefined
        if (params.subscriptionId === null || params.subscriptionId === undefined) {
            throw new utils_1.RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling updateSubscription.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateSubscription.');
        }
        const path = `/subscriptions/{subscriptionId}`
            .replace(`{${'subscriptionId'}}`, String(params.subscriptionId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
}
exports.NotificationsService = NotificationsService;
